import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import CostBreakdownChart from './CostBreakdownChart';
import ProfitTrendChart from './ProfitTrendChart';
import ProfitSummary from './ProfitSummary';

const {FiBarChart3, FiPieChart} = FiIcons;

const Analytics = ({profitData, formData, periodType}) => {
  return (
    <motion.div
      initial={{opacity: 0, x: 20}}
      animate={{opacity: 1, x: 0}}
      transition={{duration: 0.6, delay: 0.6}}
      className="space-y-6"
    >
      {/* Profit Summary */}
      <ProfitSummary profitData={profitData} periodType={periodType} />

      {/* Cost Breakdown Chart */}
      <div className="bg-white rounded-3xl shadow-xl p-8 border border-slate-200">
        <div className="flex items-center gap-3 mb-6">
          <div className="bg-gradient-to-r from-orange-500 to-red-500 p-2 rounded-xl">
            <SafeIcon icon={FiPieChart} className="text-xl text-white" />
          </div>
          <h3 className="text-2xl font-bold text-slate-800">Cost Breakdown</h3>
        </div>
        <CostBreakdownChart formData={formData} />
      </div>

      {/* Profit Trend Chart */}
      <div className="bg-white rounded-3xl shadow-xl p-8 border border-slate-200">
        <div className="flex items-center gap-3 mb-6">
          <div className="bg-gradient-to-r from-green-500 to-emerald-600 p-2 rounded-xl">
            <SafeIcon icon={FiBarChart3} className="text-xl text-white" />
          </div>
          <h3 className="text-2xl font-bold text-slate-800">Profit Projection</h3>
        </div>
        <ProfitTrendChart profitData={profitData} />
      </div>
    </motion.div>
  );
};

export default Analytics;